import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-links">
          <div className="footer-column">
            <h4>Help</h4>
            <Link to="/returns" onClick={toTop}>
              Return policy
            </Link>
            <Link to="/shipping" onClick={toTop}>
              Shipping
            </Link>
          </div>

          <div className="footer-column">
            <h4>More</h4>
            <Link to="/privacy" onClick={toTop}>
              Privacy
            </Link>
            <Link to="/terms" onClick={toTop}>
              Terms
            </Link>
            <Link to="/cookies" onClick={toTop}>
              Cookie Policy
            </Link>
            <Link to="/faqs" onClick={toTop}>
              FAQs
            </Link>
            <Link to="/contact" onClick={toTop}>
              Contact Us
            </Link>
          </div>

          <div className="footer-column">
            <h4>Connect</h4>
            <p>kit@sacuddin.shop</p>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>© Sacuddin 2026</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
